import { getDocumentNumber } from "./getDocumentNumber.js";
function getDetails(lines, fieldParsers, autocorrectArray) {
    const details = [];
    for (const [i, { parser }] of fieldParsers.entries()) {
        details.push(parser(lines, autocorrectArray[i]));
    }
    return details;
}
function getFields(details) {
    const fields = {};
    let allValid = true;
    for (const detail of details) {
        if (!detail.valid) {
            allValid = false;
        }
        if (detail.field) {
            fields[detail.field] = detail.valid ? detail.value : null;
        }
    }
    return { fields, allValid };
}
function getCorrection(lines, fieldParsers, autocorrect) {
    const corrected = lines.slice();
    let autocorrectArray = [];
    if (autocorrect) {
        for (const { autocorrector } of fieldParsers) {
            const { autocorrect, correctedText, range } = autocorrector(lines);
            autocorrectArray.push(autocorrect);
            const line = corrected[range.line];
            corrected[range.line] =
                line.slice(0, range.start) + correctedText + line.slice(range.end);
        }
    }
    else {
        autocorrectArray = new Array(fieldParsers.length).fill([]);
    }
    return { corrected, autocorrectArray };
}
export function getResult(format, lines, fieldParsers, options) {
    const { autocorrect = false } = options;
    const { corrected, autocorrectArray } = getCorrection(lines, fieldParsers, autocorrect);
    const details = getDetails(corrected, fieldParsers, autocorrectArray);
    const fields = getFields(details);
    return {
        format,
        details,
        fields: fields.fields,
        documentNumber: getDocumentNumber(format, fields.fields),
        valid: fields.allValid,
    };
}
//# sourceMappingURL=getResult.js.map